import Cookies from 'js-cookie';
import { makeAutoObservable, runInAction } from 'mobx';
import { redirect } from 'react-router-dom';
import { apiRequests } from '../../api/apiRequests';
import { routes_config, uninitialization_routes } from '../../routes/index.jsx';
import { checkOnExpiredToken } from '../../utils/checkOnExpiredToken.js';
import { axiosInstance } from '../../api/axiosInstance.js';

class UserStore {
  user = {};
  isLoading = false;
  isAuth = false;
  accessData = null;
  isInitialization = false;
  routes = routes_config;

  constructor() {
    makeAutoObservable(this);
  }

  getData = () => {
    this.isLoading = true;
    apiRequests.users.getUser().then(async (data) => {
      try {
        // const rules = await apiRequests.users.getAccessList(data.id);
        runInAction(() => {
          // this.accessData = rules;
          this.isAuth = true;
          this.isInitialization = true;
          this.user = data;
        });
      } catch (e) {
        console.error('error get user data: ', e);
      } finally {
        runInAction(() => {
          this.isLoading = false;
        });
      }
    });
  };

  updateRefreshToken = async () => {
    try {
      const response = await apiRequests.users.refreshToken(Cookies.get('refreshToken'));
      axiosInstance.defaults.headers = {
        Sessid: response.sessID,
      };
      Cookies.set('refreshToken', response.refreshToken);
      Cookies.set('expiredAt', response.expiresAt);
      Cookies.set('sid', response.sessID);
      return true;
    } catch (e) {
      console.error('error update refresh token: ', e);

      Cookies.remove('sid');
      Cookies.remove('refreshToken');
      Cookies.remove('expiredAt');
      this.isAuth = false;
      this.user = {};

      window.location.assign('/login');
      return false;
    }
  };

  updateData = (value) => {
    this.user = value;
  };

  logout = () => {
    this.isAuth = false;
    this.user = {};
    Cookies.remove('sid');
    window.location.assign('/login');
  };
}

export const userStore = new UserStore();
